import { useEffect } from 'react'
import { MingcuteInformationLine } from '../../assets/icons/Icons';
import { showToast } from '../../toastify/Toast';
import { useDispatch } from 'react-redux';
import { logOut } from '../../features/auth/authSlice';
import { useNavigate } from 'react-router-dom';
import Loading from '../ui/Loading';
import { updateCBrew } from '../../utils/updateCpBrewLocal';
import { useMutationData } from '../../hooks/api/useMutationData';

interface InformationModalProps {
    onClose: (value: boolean) => void;
    typeOfModal: string
    labelInfo: string
    typeOfProps: string
    onConfirm: () => void;
    isLoading?: boolean; 
}

export default function InformationModal({ onClose, labelInfo, typeOfProps, onConfirm }: InformationModalProps) {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { staffLogOut, isLoadingStaffLogOut, isErrorStaffLogOut } = useMutationData()
    const localData = JSON.parse(localStorage.getItem("cBrew") || "{}");
    
    useEffect(() => {
        if (isErrorStaffLogOut) {
            showToast("Logout failed!", "error");
        }
    }, [isErrorStaffLogOut]);

    const handleCancelledOrder = async () => {
        if(!typeOfProps) return;

        try {
            if(typeOfProps === 'logOut') {
                await staffLogOut().unwrap(); 
                dispatch(logOut());
                localStorage.removeItem("cBrew");
                if(onConfirm) onConfirm();
                navigate("/login-staff");
            } else if (typeOfProps === 'logOutGuest') {
                await staffLogOut().unwrap(); 
                updateCBrew({ token: localData.token,  });
                navigate(`/login?token=${localData.token}`);
                if(onConfirm) onConfirm();
            } else if(typeOfProps === 'cancelledOrder' && onConfirm) {
                onConfirm();
            } else if(typeOfProps === 'placeOrder') {
                showToast('Thank you! Your order has been placed.', 'success');
            }
        } catch (err) {
            showToast("Logout failed!", "error");
        } finally {
            onClose(false);
        }
    }

    return (
        <div className='fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-10'
        >
            <div className='relative w-[80%] mx-5 bg-white rounded-lg shadow px-5 flex md:w-[40%] lg:w-[25%]'>
                <div className='flex flex-col w-full'>
                    <div className='w-full space-y-3 py-5'>
                        <div className='w-full flex justify-center'>
                            <MingcuteInformationLine width={100} height={100}/>
                        </div>
                        <p className='text-[13px] md:text-[14px] text-center'>
                            {labelInfo}
                        </p>
                        <hr className="h-px bg-gray-200 border-0" />
                        <div className='w-full flex space-x-2'>
                            {isLoadingStaffLogOut && typeOfProps === 'logOut' ? (
                                <button
                                    className=' bg-white text-white p-2 rounded transition text-[13px] md:text-[14px] border w-full border-cbColor'
                                >
                                    <Loading setH={'h-[20px]'} message='Processing...'/>
                                </button>
                            ) : (
                                <>
                                    <button 
                                        onClick={handleCancelledOrder}
                                        disabled={isLoadingStaffLogOut}
                                        className='w-1/2 bg-cbColor text-white p-2 rounded transition text-[13px] md:text-[14px]'
                                    >
                                        Yes
                                    </button> 
                                    <button 
                                        className='w-1/2 bg-gray-400 text-white p-2 rounded transition text-[13px] md:text-[14px]'
                                        onClick={() => {
                                            onClose(false)
                                        }}
                                    >
                                        No
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
